import { $isAtNodeEnd } from "@lexical/selection";
const getSelectedNode = (selection)=>{
    const anchor = selection.anchor;
    const focus = selection.focus;
    const anchorNode = selection.anchor.getNode();
    const focusNode = selection.focus.getNode();
    if (anchorNode === focusNode) return anchorNode;
    const isBackward = selection.isBackward();
    if (isBackward) return $isAtNodeEnd(focus) ? anchorNode : focusNode;
    return $isAtNodeEnd(anchor) ? anchorNode : focusNode;
};
export { getSelectedNode };
